import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'pagination-settings',
  templateUrl: './pagination-settings.component.html',
  styleUrls: ['./pagination-settings.component.scss'],
})
export class PaginationSettingsComponent {
  @Input() limits?: number[];
  @Input() currentLimit?: number;
  @Output() limitChange = new EventEmitter<number>();

  setLimit(limit: number) {
    this.limitChange.emit(limit);
  }
}
